import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Badge, Nav, NavItem, NavLink } from 'reactstrap';
import Icon from 'utility/icomoon';
import { TabsProps } from './types';

/* -------------------------------------------------------------------------- */
/*                               Tabs Components                              */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* To use this component create the following in your main component          */
/* const [activeTab, setActiveTab] = useState(1);
  const tabs = [
    { icon: "User", title: "profile.generalData", tabId: 1 },
    { icon: "Lock", title: "profile.changePassword", tabId: 2 },
    { icon: "Map", title: "profile.mapOptions", tabId: 3 },
  ];
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };         
  Tabs is a list of the tabs you want to render
  Active Tab the current active tab
  SetActiveTab your function to toggle de active tab                               
                                                                              */
/* -------------------------------------------------------------------------- */

const Tabs: React.FC<TabsProps> = ({
  activeTab,
  toggleTab,
  tabs = [],
  vertical = false,
  checkbox = false,
  useIntl = true,
  align = 'left',
  pinActive,
  setPin
}) => {
  return (
    <Nav
      className={`${vertical ? 'nav-left' : ''} justify-content-${align}`}
      pills
      vertical={vertical}
    >
      {tabs.map((tab) => {
        const IconTag =
          typeof tab.icon === 'string' ? (
            <Icon size={18} icon={tab.icon} className={tab.title ? 'mr-1' : 'ml-50 mr-25'} />
          ) : (
            tab.icon ?? null
          );
        return (
          <NavItem key={`tabs${tab.tabId}`}>
            <NavLink active={activeTab === tab.tabId} onClick={() => toggleTab(tab.tabId)} id={`tabplantrabajo_${tab.tabId}`}>
              {!checkbox ? IconTag : tab.checkboxComponent}
              {tab.title && (
                <span className="font-weight-bold">
                  {useIntl && (tab.useIntl === undefined ? true : tab.useIntl) ? (
                    <FormattedMessage id={tab.title} />
                  ) : (
                    tab.title
                  )}
                </span>
              )}
              &nbsp;&nbsp;
              {tab.indicator && (
                <Badge className="badge-pill-tab-custom" pill>
                  {tab.indicator}
                </Badge>
              )}
              {activeTab === tab.tabId && tab.usePin && setPin && (
                <Icon
                  size={18}
                  icon={
                    pinActive
                      ? pinActive === tab.tabId
                        ? 'PaperPinBlack'
                        : 'PaperPinWhite'
                      : 'PaperPinWhite'
                  }
                  className={'ml-1'}
                  onClick={() => {
                    setPin(tab.tabId);
                  }}
                />
              )}
            </NavLink>
          </NavItem>
        );
      })}
    </Nav>
  );
};

export default Tabs;
